export default "__VITE_ASSET__DS$ziU_Y__"